const evb_success_title = document.querySelector('.evb-s-title');

if (Boolean(evb_success_title)) {

    //window.addEventListener('load', verifyEmail);

    function getQueryParameterByName(name) {
        var url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    function verifyEmail() {
        try {


            const evb_success_text = document.querySelector('.evb-s-text');
            const evb_failure_title = document.querySelector('.evb-f-title');
            const evb_failure_text = document.querySelector('.evb-f-text');
            const evb_error_title = document.querySelector('.evb-e-title');
            const evb_error_text = document.querySelector('.evb-e-text');
            const evb_spinner = document.querySelector('.evb-spinner');
            const env = getQueryParameterByName('env');

            evb_spinner && evb_spinner.classList.remove('d-none');
            const accountNum = getQueryParameterByName('accountNumber');
            const uniqueId = generateUniqueID();

            const payload = {
                accountNumber: accountNum,
                otp: getQueryParameterByName('token'),
                flow: getQueryParameterByName('flow')
            };

            const current_hostname = window.location.hostname;
            const submiturl = `https://${current_hostname}/wuconnect/auth/v1/factors/verify`;


            const fetchCall = fetch(submiturl, {
                method: 'POST',
                headers: {
                    "Content-type": "application/json",
                    "x-wu-accountNumber": accountNum,
                    "x-wu-externalRefId": uniqueId,
                    "x-wu-correlationId": uniqueId
                },
                body: JSON.stringify(payload)
            }).then(response => {
                return response.json();
            }).then(response => {
                return response;
            }).catch(error => {
                evb_spinner && evb_spinner.classList.add('d-none');
                console.error(error);
            });

            fetchCall.then((response) => {
                evb_spinner && evb_spinner.classList.add('d-none');
                if (response && response.status) {
                    if (response.status === 'FAILURE') {
                        evb_failure_title && evb_failure_text && (evb_failure_title.classList.replace('d-none', 'd-flex'), evb_failure_text.classList.remove('d-none'));
                    } else if (response.status === 'SUCCESS') {
                        evb_success_title && evb_success_text && (evb_success_title.classList.replace('d-none', 'd-flex'), evb_success_text.classList.remove('d-none'));
                    } else {
                        // need to replace this with new block once confirmation received from PO.
                        evb_error_title && evb_error_text && (evb_error_title.classList.replace('d-none', 'd-flex'), evb_error_text.classList.remove('d-none'));
                    }
                } else {
                    evb_error_title && evb_error_text && (evb_error_title.classList.replace('d-none', 'd-flex'), evb_error_text.classList.remove('d-none'));
                }
            });
        }
        catch (ex) {
            console.log(ex);
        }
    }

    function generateUniqueID() { // Public Domain/MIT
        var d = new Date().getTime();//Timestamp
        var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16;//random number between 0 and 16
            if(d > 0){//Use timestamp until depleted
                r = (d + r)%16 | 0;
                d = Math.floor(d/16);
            } else {//Use microseconds since page-load if supported
                r = (d2 + r)%16 | 0;
                d2 = Math.floor(d2/16);
            }
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    }
}